import React from "react"
import Top from "./components/Top";
import Bottom from "./components/Bottom";
import Footer from "./components/Footer";

export default function App() {
    return(
        <div>
            <Top/>
            <Bottom/>
            <Footer/>
        </div>
    )
}
